import React from 'react';
import Button from 'components/CustomButtons/Button.js';

export default function ExportTableExcel({ nameFile, idTable }) {
  const exportTableToExcel = () => {
    /* var dataType = `application/vnd.ms-excel;charset=utf-8,%EF%BB%BF`; */
    /* var dataType = `application/vnd.ms-excel;charset=UTF-8`; */
    var dataType = 'text/xls;charset=utf-8,%EF%BB%BF';
    var tableSelect = document.getElementById(idTable);
    if (!tableSelect) return alert('No se encontró la tabla');
    var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');
    // Especificar el nombre del archivo
    const fileName = `${nameFile}.xls`;
    // Crear elemento de enlace de descarga
    let downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    /* if (navigator.msSaveOrOpenBlob) {
      var blob = new Blob(['ufeff', tableHTML], {
        type: dataType
      });
      navigator.msSaveOrOpenBlob(blob, fileName);
    } else { */
    // Crear un enlace al archivo
    /* downloadLink.href = 'data:' + dataType + ', ' + tableHTML; */
    downloadLink.href = 'data:' + dataType + tableHTML;
    // Configuración del nombre del archivo
    downloadLink.download = fileName;
    //Activar la funcion
    downloadLink.click();
    /* } */
  };

  return (
    <Button color="success" onClick={exportTableToExcel}>
      Exportar
    </Button>
  );
}
